import { Snackbar } from '@material-ui/core';
import Alert from '@material-ui/lab/Alert';
import React from 'react';
import { connect } from 'react-redux';
import { closeAlert } from '../../redux/alerts/action';

const CustomAlerts = ({ alertType, alertMsg, snackbar, closeAlert }) => {
	return (
		<Snackbar
			anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
			open={snackbar}
			onClose={() => closeAlert()}
			autoHideDuration={3000}
		>
			<Alert severity={alertType} variant='filled' elevation={6}>
				{alertMsg}
			</Alert>
		</Snackbar>
	);
};

export default connect(null, { closeAlert })(CustomAlerts);
